"use strict";

jQuery(document).ready(function ($) {
  $('.statement-carousel__images').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: '<span class="statement-carousel__images__arrow statement-carousel__images__arrow--prev"></span>',
    nextArrow: '<span class="statement-carousel__images__arrow statement-carousel__images__arrow--next"></span>',
    speed: 400,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'statement-carousel__dots',
    dots: true
  });
});